import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../../../page/operatingprocedure/operatingprocedure.component';

@Component({
    selector: 'app-add-op-dialog',
    templateUrl: './add-op-dialog.component.html',
    styleUrls: ['./add-op-dialog.component.scss'],
    standalone: false ,  // NOSONAR
})
export class AddOpDialogComponent implements OnInit {

	description;
	url;
	heading;
	action;
	local_data;
	enableError: boolean = false;
	errormsg;

	constructor(public dialogRef: MatDialogRef<AddOpDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData) {
		if (this.dataStore.performAction == 'EditCell') {  // NOSONAR
			this.heading = "Edit"; 
			this.action = 'EditCell';
			this.description = this.dataStore.placeholderdesc;
			this.url = this.dataStore.placeholderurl;
		}
		else {
			this.heading = "Add";
			this.action = 'AddCell';
		}
	}

	ngOnInit(): void { // NOSONAR
		//  do something 
	}
	onNoClick(): void {
		this.dialogRef.close();
	}
	close(): void {
		this.dialogRef.close();
	}
	public saveClick() {


		if (!this.url || !this.description || this.url.trim().length == 0 || this.description.trim().length == 0) {  // NOSONAR
			this.enableError = true;
			this.errormsg = 'Please fill in the required fields!'
		}

		else {

			this.dialogRef.close({ event: this.action, data1: this.description, data2: this.url });
		}
	}

}
